import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../../layout/BaseLayout";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import { adminSsoAuth, validateAuthToken } from "../../services/authServices";
import { useNavigate } from "react-router-dom";

const dragModal = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};

function Login(props) {
   let toast = useContext(ThemeContext);
   const [show, setShow] = useState(true);
   const [loginUserError, setLoginUserError] = useState(false);
   const [loginPassError, setLoginPassError] = useState(false);
   const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('rememberData') ? true : false);
   const [loginData, setLoginData] = useState({
      username: "",
      password: "",
   });

   const [showPassword, setShowPassword] = useState(false);

   let navigate = useNavigate();

   const handleClose = () => {
      setShow(false);
      setShowPassword(false);
   }

   const adminLoginApi = async () => {
      if (!loginData.username || loginData.username === "") {
         setLoginUserError(true)
      }else{
         setLoginUserError(false)
      }

      if (!loginData.password || loginData.password === "") {
         setLoginPassError(true);
      }else{
         setLoginPassError(false);
      }
      
      if((!loginData.username || loginData.username === "") || (!loginData.password || loginData.password === "")){
         return false
      }

      adminSsoAuth(loginData).then((res) => {
         if (!!res && !!res.isSuccess) {
            sessionStorage.setItem("token", res.data.token);
            if (rememberMe) {
               localStorage.setItem("rememberData", JSON.stringify(loginData));
            }
            validateToken(res?.successMessage);
         } else {
            toast.error(
               !!res.exception && !!res.exception.message && res.exception.message
            );
         }
      });
   };

   const validateToken = async (successMessage) => {
      validateAuthToken().then((res) => {
         if (res.isSuccess) {
            if (res.data.role == "Admin" || res.data.role == "AdminOfficeUser") {
               sessionStorage.setItem("userAuthData", JSON.stringify(res.data));
               toast.success(successMessage);
               setShow(false);
               window.location.href = "/home";
            } else {
               toast.error('This user is not allowed to access this portal.')
               navigate('/')
            }
         } else {
            toast.error(
               !!res &&
               !!res.exception &&
               !!res.exception.message &&
               res.exception.message
            );
         }
      });
   };

   const handleKey = (e) => {
      if (e.keyCode === 13) {
         adminLoginApi()
      }
   }

   const updatedLogin = (field, value) => {
      let data = loginData;
      data[field] = value;
      setLoginData({ ...data });
   };

   const handleRememberMeChange = (event) => {
      if(event.target.checked == false){
         localStorage.removeItem('rememberData')
      }
      setRememberMe(event.target.checked);
   };

   useEffect(() => {
      if (!!localStorage.getItem("rememberData")) {
         const storedPassword = JSON.parse(localStorage.getItem("rememberData"));
         localStorage.clear();
         localStorage.setItem('rememberData', JSON.stringify(storedPassword));
         if (storedPassword) {
            setRememberMe(true);
            updatedLogin("password", storedPassword.password);
            updatedLogin("username", storedPassword.username);
         }
      } else {
         localStorage.removeItem('rememberData');
      }
   }, []);

   // useEffect(()=>{
   //    if(!rememberMe){
   //       sessionStorage.removeItem('rememberData')
   //    }
   // },[rememberMe])

   return (
      <>
         <div id="tabs">
            <div className="login-popup">
               <Modal
                  className="login"
                  show={show}
                  onHide={() => handleClose()}
                  backdrop="static"
                  dialogAs={dragModal}
                  animation={false}
                  size="md"
                  centered
               >
                  <Modal.Header closeButton style={{ border: "none" }}>
                     <Modal.Title className="w-100">
                        Login
                        <div className="btn-help d-inline-block float-right ">
                        {/* <i className="fa-question fa-solid font-size-16 mt-1"></i> */}
                        </div>
                     </Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                     <div className="p1">
                        <div className="d-flex">
                           <img
                              className="modelbody-img"
                              src={"/images/svg/login.svg"}
                              alt=""
                           />
                           <span className="normaltext-1">
                              Please enter your Valid Credentials for Login.
                           </span>
                        </div>
                        <div className="mt-2 loginbox">
                           <table
                              border="0"
                              cellSpacing="0"
                              cellPadding="0"
                              className="w-90"
                           >
                              <tbody>
                                 <tr>
                                    <td className="font11 text-right ">Login : </td>
                                    <td
                                       className={
                                          loginUserError ? "loginUser error" : "loginUser"
                                       }
                                    >
                                       <input
                                          type="text"
                                          className="inputborder font11 mb-0 ml-1 h20 width-120 mb-1"
                                          value={loginData.username}
                                          maxLength={50}
                                          autoFocus
                                          onChange={(e) => {
                                             const allowNumericOnly = e.target.value.replace(/\D/g, "");
                                             updatedLogin("username", allowNumericOnly);
                                             (loginData?.username !== '' ? setLoginUserError(false) : setLoginUserError(true));
                                          }}
                                          onKeyDown={(e) => { handleKey(e) }}
                                       />
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className="font11 text-right">Password : </td>
                                    <td className={loginPassError ? "error" : ""}>
                                       <input
                                          type={`${showPassword ? 'text' : 'password'}`}
                                          className={
                                             loginPassError
                                                ? "inputborder font11 mb-0 ml-1 h20 width-120 mr-3 error"
                                                : "inputborder font11 mb-0 ml-1 h20 width-120 mr-3"
                                          }
                                          value={loginData.password}
                                          maxLength={50}
                                          onChange={(e) => {
                                             updatedLogin("password", e.target.value);
                                             (loginData?.password !== '' ? setLoginPassError(false) : setLoginPassError(true));
                                          }}
                                          onKeyDown={(e) => { handleKey(e) }}
                                       />
                                       <i className={`fa fa-${!showPassword ? 'eye-slash password-check ' : 'eye password-check'} logineye remove_arrow_summary`} onClick={() => setShowPassword(!showPassword)}></i>
                                       <label className="form-check-label ml-4 font11">
                                          <input
                                             className="form-check-input mr-2"
                                             type="checkbox"
                                             name="remember"
                                             checked={rememberMe}
                                             onChange={handleRememberMeChange}
                                          />
                                          Remember Me
                                       </label>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                     <div className="hr mt-2"></div>
                     <div>
                        <div className="w-100 text-center">
                           <Button
                              onClick={() => adminLoginApi()}
                              className="btnmain mr-3"
                           >
                              Login
                           </Button>
                           <Button onClick={() => handleClose()} className="btnmain-danger">
                              Cancel
                           </Button>
                        </div>
                     </div>
                  </Modal.Body>
               </Modal>
            </div>
         </div>
      </>
   );
}
export default Login;
